import { Component, OnInit, HostListener } from '@angular/core';
import * as jQ from 'jquery';

@Component({
  selector: 'app-muay-thai',
  templateUrl: './muay-thai.component.html',
  styleUrls: ['./muay-thai.component.css']
})
export class MuayThaiComponent implements OnInit {
	
	@HostListener('document:scroll', ['$event']) onScroll(e) {
		let scrollPosition = window.scrollY;
		let height = window.innerHeight;
		let opacity = ((height-scrollPosition)/height);
		jQ('.bg-img').css('opacity', opacity);
	}

  constructor() { }

  ngOnInit() {
  }

}
